import React from "react";
import ContactBox from "../components/ContactBox";
import { Link } from "react-router-dom";

const Contact = () => {
  return (
    <>
      <main className="main-content site-wrapper-reveal">
        <section
          className="page-content-area "
          data-bg-img="assets/img/photos/bg-page-title.webp"
          style={{
            backgroundImage: `url("../../assets/img/product_img_cover.jpg")`,
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-title-content text-center">
                  <h1 className="title text-white">Contact Us</h1>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="contact-modern-area section-space">
          <div className="container">
            <div className="row g-0 premium-contact-wrapper">
              {/* LEFT SIDE: Showroom & Admin (Dark/Gold Theme) */}
              <div className="col-lg-7">
                <div className="contact-panel-dark">
                  <div className="panel-overlay"></div>
                  <div className="panel-content">
                    <span className="panel-label">
                      Visit Our Experience Center
                    </span>
                    <h2 className="panel-title">
                      Showroom & <br />
                      <span className="gold-text">Adm. Office</span>
                    </h2>

                    <div className="address-block">
                      <div className="icon-box">
                        <i className="fa fa-map-marker-alt"></i>
                      </div>
                      <p>
                        <strong>1st Floor, Sachi House,</strong>
                        <br />
                        Above Patel Ice Cream, Commerce Six Road,
                        <br />
                        Navrangpura, <br />
                        Ahmedabad, Gujarat.
                      </p>
                    </div>
                    <br></br>

                    <div className="contact-footer">
                      <div className="contact-link-group">
                        <i className="fa fa-phone-alt"></i>
                        <div className="links">
                          <a href="tel:+917926442095">+91 79 2644 2095 / 96</a>
                          {/* <br></br>
                          <a href="tel:+917926442096">2644 2096</a> */}
                        </div>
                      </div>
                      <br></br>
                      <div className="contact-link-group">
                        <i className="fa fa-envelope-open"></i>
                        <div className="links">
                          <a href="mailto:sales@sachiproducts.com">
                            sales@sachiproducts.com
                          </a>
                          <br></br>
                          <a href="mailto:info@sachiproducts.com">
                            info@sachiproducts.com
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* RIGHT SIDE: Works & Packaging (Clean White/Gold Theme) */}
              <div className="col-lg-5">
                <div className="contact-panel-light">
                  <div className="panel-content">
                    <h3 className="sub-panel-title">
                      Packaging Division Office
                    </h3>

                    <div className="address-block-light">
                      <p>
                        G-7, Ravi Estate, Dudheswar,
                        <br /> Ahmedabad
                      </p>
                    </div>

                    <div className="phone-stack">
                      <div className="phone-row">
                        <span className="label">Tel:</span>
                        <a href="tel:+917925625184">079-25625184 / 85</a>
                      </div>
                      <div className="phone-row mt-3">
                        <span className="label mobile">Mobile:</span>
                        <a href="tel:+919537557989" className="mobile-link">
                          +91 9537557989
                        </a>
                      </div>
                    </div>

                    {/* <div className="action-button-group">
                      <a
                        href="https://maps.google.com"
                        target="_blank"
                        className="btn-directions"
                      >
                        Get Directions <i className="fa fa-chevron-right"></i>
                      </a>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="container-fluid">
          <div className="contact-map-area pt-80">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4517.723973184111!2d72.5546118!3d23.0403956!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e85c1db177071%3A0x5e16ca356773e748!2sSachi%20Products!5e1!3m2!1sen!2sin!4v1762424301314!5m2!1sen!2sin"
              width="600"
              height="450"
              style={{ border: "0px" }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </main>
    </>
  );
};
export default Contact;
